// extracted by mini-css-extract-plugin
module.exports = {"aboutAssessmentSection":"AboutAssessmentSection_aboutAssessmentSection__9SJiG"};